﻿function getForm() {
    return $("[data-used-car-sales-figure-form]");
}


function submitForm() {
    const form = getForm();
    form.submit();
}

export function setupUsedCarSalesFigures() {
    $("#used-car-sales-figure .tab-content .tab-pane:first-child").addClass("active");

    $(document).on("change", "[data-used-car-sales-figure-form] #Quarter", submitForm);
}
